import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const getAllSRExpense = createAsyncThunk(
  "ExpenseDetails/FindAllSrExpenseList",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExpenseDetails/FindAllSrExpenseList`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching SR Expense:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createSRExpense = createAsyncThunk(
  "ExpenseDetails/InsertExpenseDetails",
  async (Item: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExpenseDetails/InsertExpenseDetails`,
        Item
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Item:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateSRExpense = createAsyncThunk(
  "ExpenseDetails/UpdateExpenseDetails",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExpenseDetails/UpdateExpenseDetails`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error update SR Expense:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getSRExpenseByID = createAsyncThunk(
  "ExpenseDetails/FindByIDExpenseDetails",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExpenseDetails/FindByIDExpenseDetails`,
        { expense_details_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        id: result?.id,
        expense_details_guid: result?.expense_details_guid,
        expense_date: result?.expense_date
          ? moment(result?.expense_date, "YYYY-MM-DD").toDate()
          : "",
        from_city: result?.from_city,
        to_city: result?.to_city,
        mode_of_transport: result?.mode_of_transport,
        city_town_visited: result?.city_town_visited.split(",")?.map(Number),
        sales_amount: result?.sales_amount,
        remarks: result?.remarks,
        fixed_expense: result?.fixed_expense,
        expense_details_list: result?.expense_details_list,
        total_amount: result?.total_amount,
        kms_travelled: result?.kms_travelled,
        fare_for_transport: result?.fare_for_transport,
        net_amount: result?.net_amount,
        sr_id: result?.sr_id,
        sr_name: result?.sr_name,
        petrol_rate_per_km:result?.petrol_rate_per_km,
        from_city_name: result?.from_city_name,
        city_town_visisted_name: result?.city_town_visisted_name,
        to_city_name: result?.to_city_name,
        mode_of_transport_name: result?.mode_of_transport_name,
        disallowed_amount: result?.disallowed_amount,
        additional_expense_amount: result?.additional_expense_amount,
        verification_remarks: result?.verification_remarks,
        verification_status: result?.verification_status,
        verify_by: result?.verify_by,
        verify_by_name: result?.verify_by_name,
        verification_date: result?.verification_date
          ? moment(result?.verification_date, "YYYY-MM-DD").toDate()
          : "",
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching SR Expense:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteSRExpense = createAsyncThunk(
  "ExpenseDetails/DeleteExpenseDetails",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExpenseDetails/DeleteExpenseDetails`,
        { expense_details_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting SR Expense:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
